function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 .322h40.037v30.244H0z"
}));

var _ref2 = React.createElement("g", {
  id: "slide_1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(88 57)"
}, React.createElement("path", {
  d: "M.347 82.71c0 6.169 7.796 11.17 17.414 11.17 9.617 0 17.414-5.001 17.414-11.17 0-6.167-7.797-11.168-17.414-11.168-9.618 0-17.414 5-17.414 11.169",
  id: "Fill-1",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M3.762 84.662c0 6.168 7.796 11.169 17.414 11.169 9.617 0 17.414-5.001 17.414-11.169s-7.797-11.169-17.414-11.169c-9.618 0-17.414 5.001-17.414 11.169z",
  id: "Stroke-3",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M3.762 84.662v10.329c0 6.168 7.796 11.169 17.414 11.169 9.617 0 17.414-5.001 17.414-11.169V84.662",
  id: "Stroke-5",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  id: "Fill-7",
  fill: "#FFC5C5",
  d: "M3.677 239.355l-1.75-12.75 14.5-7.5 18.75 5 1.5 11.75-13.25 9.79z"
}), React.createElement("path", {
  id: "Stroke-9",
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M6.594 240.022l-.747-12.75 13.497-7.5 18.75 5 1.5 11.75-13.25 10.31z"
}), React.createElement("path", {
  id: "Stroke-11",
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M39.597 236.353v9.668l-13.003 10.311-19.75-6.81-.25-9.5"
}), React.createElement("path", {
  d: "M26.344 246.832l.25 9.5",
  id: "Stroke-13",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M23.86 0S2.648 15.322 3.417 15.322l23.702 17.981L23.86 0z",
  id: "Fill-15",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M26.706 2.135S5.494 17.457 6.264 17.457l23.702 17.98-3.26-33.302z",
  id: "Stroke-17",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  id: "Stroke-19",
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M29.965 35.438V45.52L6.264 27.539V17.457v7.177"
}), React.createElement("g", {
  id: "Group-23",
  transform: "translate(0 140.754)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  id: "Fill-21",
  fill: "#EBFFC0",
  mask: "url(#b)",
  d: "M0 16.432l18.237 14.134 21.8-15.956L21.829.322z"
})), React.createElement("path", {
  id: "Stroke-24",
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M3.52 157.186l18.236 14.134 21.8-15.956-18.207-14.288z"
}), React.createElement("path", {
  d: "M44.07 155.495l.027 11.66c-.127.055-22.058 16.018-22.058 16.018",
  id: "Stroke-26",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  id: "Stroke-28",
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M3.028 156.993v11.379l18.729 14.327v-11.473"
})), React.createElement("text", {
  id: "Data",
  fontFamily: "Montserrat-Light, Montserrat",
  fontSize: 12,
  fontWeight: 300,
  fill: "#28348A"
}, React.createElement("tspan", {
  x: 154,
  y: 149
}, "Data")), React.createElement("text", {
  id: "Process",
  fontFamily: "Montserrat-Light, Montserrat",
  fontSize: 12,
  fontWeight: 300,
  letterSpacing: -0.311,
  fill: "#28348A"
}, React.createElement("tspan", {
  x: 153,
  y: 223
}, "P"), React.createElement("tspan", {
  x: 160.957,
  y: 223,
  letterSpacing: -0.169
}, "r"), React.createElement("tspan", {
  x: 165.348,
  y: 223
}, "o"), React.createElement("tspan", {
  x: 172.788,
  y: 223,
  letterSpacing: -0.108
}, "c"), React.createElement("tspan", {
  x: 179.232,
  y: 223
}, "ess")), React.createElement("text", {
  id: "Cognitive-knowledge-",
  fontFamily: "Montserrat-Light, Montserrat",
  fontSize: 12,
  fontWeight: 300,
  letterSpacing: -0.288,
  fill: "#28348A"
}, React.createElement("tspan", {
  x: 153,
  y: 76
}, "C"), React.createElement("tspan", {
  x: 161.016,
  y: 76
}, "ogniti"), React.createElement("tspan", {
  x: 195.756,
  y: 76,
  letterSpacing: -0.18
}, "v"), React.createElement("tspan", {
  x: 201.732,
  y: 76
}, "e"), React.createElement("tspan", {
  x: 211.98,
  y: 76,
  letterSpacing: -0.108
}, "k"), React.createElement("tspan", {
  x: 218.82,
  y: 76,
  letterSpacing: 0.013
}, "n"), React.createElement("tspan", {
  x: 226.921,
  y: 76,
  letterSpacing: -0.182
}, "o"), React.createElement("tspan", {
  x: 233.999,
  y: 76
}, "wledge")), React.createElement("text", {
  id: "AI-Components",
  fontFamily: "Montserrat-Light, Montserrat",
  fontSize: 12,
  fontWeight: 300,
  fill: "#28348A"
}, React.createElement("tspan", {
  x: 153,
  y: 296
}, "AI"), React.createElement("tspan", {
  x: 168.084,
  y: 296,
  letterSpacing: -0.288
}, "C"), React.createElement("tspan", {
  x: 176.1,
  y: 296
}, "ompo"), React.createElement("tspan", {
  x: 211.848,
  y: 296,
  letterSpacing: 0.012
}, "n"), React.createElement("tspan", {
  x: 219.948,
  y: 296
}, "ents")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_1.svg